import logger from './features/middleware/logger/logger.middleware'
const middleware = [
  logger
  // Add your middleware here
]
export default middleware
